import {ReactElement} from "react"

const NeighbourIcon = ({disabled}: {disabled?: boolean}): ReactElement => {
	return (
    <svg width="41" height="36" viewBox="0 0 41 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 0C23.2091 0 25 1.79086 25 4C25 5.15601 24.5087 6.1965 23.7246 6.92676L34.6953 24.8037C34.9894 24.7557 35.2914 24.7295 35.5996 24.7295C38.5818 24.7295 40.9997 27.0709 41 29.959C41 32.8473 38.5819 35.1895 35.5996 35.1895C33.4136 35.1893 31.532 33.9305 30.6826 32.1211H12.0518C10.9104 33.8473 8.85121 35 6.5 35C2.91015 35 0 32.3137 0 29C0 25.6863 2.91015 23 6.5 23C7.11387 23 7.70754 23.0798 8.27051 23.2266L18.2744 6.92676C17.4906 6.19652 17 5.15575 17 4C17 1.79086 18.7909 0 21 0ZM12.2793 26.2549C12.434 26.5318 12.5658 26.8211 12.6729 27.1211H30.251L21 12.0459L12.2793 26.2549Z"
        fill={disabled ?"#7E8591" : "url(#linear-gradient-009DA9-1FD7E5)"}
        fillOpacity={disabled ? 0.37 : 1}
      />
      <defs>
        <linearGradient
          id="linear-gradient-009DA9-1FD7E5"
          x1="6.5"
          y1="23"
          x2="6.5"
          y2="35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#009DA9"/>
          <stop offset="1" stopColor="#1FD7E5"/>
        </linearGradient>
      </defs>
    </svg>
  )
}

export default NeighbourIcon
